import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DxButtonModule } from 'devextreme-angular';
import { NewVersionReloadService } from '../../services/new-version/new-version-reload.service';
import { NewVersionService } from '../../services/new-version/new-version.service';

/**
 * Stays in the DOM while there is nothing to report, so its status region
 * already exists when the message arrives: screen readers announce a change
 * inside a live region far more reliably than a region inserted with its text.
 * Its height comes from `--new-version-notice-height`, which `app-root` sets.
 */
@Component({
  selector: 'app-new-version-notice',
  imports: [TranslateModule, DxButtonModule],
  templateUrl: './new-version-notice.component.html',
  styleUrl: './new-version-notice.component.scss',
})
export class NewVersionNoticeComponent {
  protected readonly versions = inject(NewVersionService);
  protected readonly reload = inject(NewVersionReloadService);
}
